import { useTranslation } from 'react-i18next';
import { useDefaultSave } from './store';
import { usePlacesStore } from '@/features/places';

type Props = {
  istat: string;
  className?: string;
};

export function AddToShortlistButton({ istat, className }: Props) {
  const { t } = useTranslation();
  const { isSaved, toggle } = useDefaultSave(istat);

  // Синхронизируем usePlacesStore (SearchBar-избранное) с ShortlistStore:
  // после сохранения/удаления в DetailsPanel сразу отражаем в SearchBar.
  // Работает в одну сторону (Details → SearchBar); обратная синхронизация
  // (SearchBar-звезда → Shortlist) — отдельная задача.
  const handleClick = () => {
    const wasSaved = isSaved;
    toggle();
    const placesComuni = usePlacesStore.getState().selection.comuni;
    const isInPlaces = placesComuni.includes(istat);
    // Желаемое состояние = !wasSaved. Если Places отличается — синхронизируем.
    if ((!wasSaved) !== isInPlaces) {
      usePlacesStore.getState().toggle('comune', istat);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`inline-flex items-center gap-1 rounded-md border px-2 py-1 text-xs transition-colors ${
        isSaved
          ? 'border-amber-300 bg-amber-50 text-amber-900 hover:bg-amber-100'
          : 'border-slate-300 bg-white text-slate-700 hover:bg-slate-50'
      } ${className ?? ''}`}
      title={isSaved ? t('shortlist.unsave', { defaultValue: 'Remove from saved' }) : t('shortlist.save', { defaultValue: 'Save' })}
      aria-label={isSaved ? t('shortlist.unsave', { defaultValue: 'Remove from saved' }) : t('shortlist.save', { defaultValue: 'Save' })}
      aria-pressed={isSaved}
    >
      {isSaved ? '★' : '☆'}{' '}
      {isSaved ? t('shortlist.saved', { defaultValue: 'Saved' }) : t('shortlist.save', { defaultValue: 'Save' })}
    </button>
  );
}
